import _ from  'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { Card, Icon } from 'semantic-ui-react'

const JobCounter = (props) => {
  return (
    <Card>
      <Card.Content textAlign="center">
        <Icon name="tasks" size={'huge'} />
      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>{_.size(props.jobs)}</Card.Header>
      </Card.Content>
      <Card.Description textAlign="center">
        {_.size(props.jobs)} jobs.
      </Card.Description>
    </Card>
  )
}
JobCounter.displayName = 'JobCounter'
JobCounter.propTypes = {
  jobs: PropTypes.object
}
export default JobCounter



// WEBPACK FOOTER //
// ./src/components/dashboard/JobCounter.js